import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import type { MenuItem } from 'primeng/api';
import * as FlatModels from '@medsurf/flat-models';

@Component({
    selector: 'medsurf-design-content-breadcrumb',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './breadcrumb.content.design.html',
    styleUrls: ['./breadcrumb.content.design.scss'],
    standalone: false
})
export class BreadcrumbContentDesign {
  @Input({ required: true }) items!: MenuItem[];
  
  readonly home = {
    icon: FlatModels.ButtonDesignModels.ButtonDefaultIcons.HOUSE,
    routerLink: '/'
  };
}
